'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import GlobalHelper from '../../Common/Helpers/GlobalHelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_DISTRIBUCION,
    GET_SCREEN_DATA_RESULTADO_DISTRIBUCION,
    CHANGE_LIMITE,
    SELECT_ADM,
    CANCELAR,
    GUARDAR,
    SET_USER_FUNCTIONS_DISTRIBUCION,
    CAMBIAR_ESTADO_EDICION_EMPRESAS,
    CAMBIAR_ESTADO_EDICION_CUENTAS,
    CAMBIAR_ESTADO_EDICION_TARJETAS,
    CLOSE_MODAL_ESTA_EDITANDO,
    OPEN_MODAL_ESTA_EDITANDO,
    READY_REQUEST_LIMITES,
    SHOW_SAVE_STATUS_LIMITES,
    OBTENER_LIMITE_CUENTA_POR_PRODUCTO,
    RENDER_RANDOM
} from '../../Screens/DistribucionLimites/actions/DistribucionLimitesActions';

/**
 * Estado inicial.
 */
const initialState = {
    selectLimit: undefined,
    limiteCompra: undefined,
    selectAdm: undefined,
    moveToButtonInPrincipal: undefined,
    pasoPorEmpresa: false,
    pasoPorCuenta: false,
    pasoPorTarjeta: false,
    administradoras: [],
    empresas: [],
    cuentas: [],
    tarjetas: [],
    novedadesEmpresas: [],
    novedadesCuentas: [],
    novedadesTarjetas: [],
    empresasOriginal: [],
    cuentasOriginal: [],
    tarjetaOriginal: [],
    empresasNoModificadas: [],
    cuentasNoModificadas: [],
    tarjetaNoModificadas: [],
    datosCliente: [],
    functions: { Confidencial: true },
    limiteCliente: undefined,
    administradoraSeleccionadaId: undefined,
    seEstaEditando: false,
    mostrarMensajeLimitesIguales: false,
    functions: {},
    selectCuentasId: undefined,
    selectEnterpriseId: undefined,
    //Estado propio, no compartido con los hijos...
    abrirModalEstaEditando: false,
    limiteEmpresaExcedido: undefined,
    limiteCuentaExcedido: undefined,
    limiteTarjetasExcedido: undefined,

    //Flag que indica que se realizo una modificacion...
    seModifico: false,

    //Se utilizan para resaltar en negritas los combos de distribucion...
    empresaExcedida: [],
    cuentaExcedida: [],

    //Spinner de Aceptar
    readyRequest: false
};

let result;
function distribucionLimites(state = initialState, action) {
    LogHelper.In(distribucionLimites.name, state, action);

    switch (action.type) {

        case GET_SCREEN_DATA_DISTRIBUCION:

            result = {
                ...state,
                Loading: false,
                selectLimit: undefined,
            }
            break;

        case GET_SCREEN_DATA_RESULTADO_DISTRIBUCION:

            let selectedEnterprise = action.resultado.empresas.find(x => x.seleccionada == true);

            result = {
                ...state,
                limiteCompra: action.resultado.limiteCompra,
                administradoras: action.resultado.administradoras,
                empresas: action.resultado.empresas,
                cuentas: action.resultado.cuentas,
                tarjetas: action.resultado.tarjetas,
                empresasOriginal: action.resultado.empresas,
                cuentasOriginal: action.resultado.cuentas,
                tarjetaOriginal: action.resultado.tarjetaOriginal,
                novedadesEmpresas: action.resultado.novedadesEmpresas,
                novedadesCuentas: action.resultado.novedadesCuentas,
                novedadesTarjetas: action.resultado.novedadesTarjetas,
                empresasNoModificadas: action.resultado.empresasNoModificadas,
                cuentasNoModificadas: action.resultado.cuentasNoModificadas,
                tarjetasNoModificadas: action.resultado.tarjetasNoModificadas,
                datosCliente: action.resultado.datosCliente,
                selectLimit: action.paginaInicial,
                limiteCliente: action.limiteCliente,
                administradoraSeleccionadaId: action.administradoraSeleccionadaId,
                selectEnterpriseId: undefined
            }
            break;

        case CHANGE_LIMITE:

            let _pasoEmpresa = state.pasoPorEmpresa;
            let _pasoCuenta = state.pasoPorCuenta;
            let _pasoTarjeta = state.pasoPorTarjeta;
            switch (action.valueId) {
                //Empresa
                case 0:
                    _pasoEmpresa = true;
                    break;
                //Cuenta
                case 1:
                    _pasoCuenta = true;
                    break;
                //Tarjeta
                case 2:
                    _pasoTarjeta = true;
                    break;
            }
            result = {
                ...state,
                selectLimit: action.valueId,
                pasoPorEmpresa: _pasoEmpresa,
                pasoPorCuenta: _pasoCuenta,
                pasoPorTarjeta: _pasoTarjeta,
                abrirModalEstaEditando: false,
                seModifico: true
            }
            break;

        case SELECT_ADM:

            let sAdm = action.valueId !== undefined ? parseInt(action.valueId) : action.valueId

            result = {
                ...state,
                selectAdm: sAdm
            }
            break;

        case OBTENER_LIMITE_CUENTA_POR_PRODUCTO:

            result = {
                ...state,
                limiteCompra: action.limiteCompra
            }
            break;

        case RENDER_RANDOM:

            result = {
                ...state
            }
            break;

        case CANCELAR:

            let estado = state;
            result = {
                ...state,
                empresas: estado.empresasOriginal,
                cuentas: estado.cuentasOriginal,
                tarjetas: estado.tarjetaOriginal,
                abrirModalEstaEditando: false,
            }
            break;

        case GUARDAR:

            result = {
                ...state,
                abrirModalEstaEditando: false
            }
            break;

        case CAMBIAR_ESTADO_EDICION_EMPRESAS: {
            
            const { cuentas, tarjetas, novedadesCuentas, novedadesTarjetas, limiteCompra } = state;
            const { empresas, novedadesEmpresas, cliente } = action.data;
           
            let excesoLimite = _verificarExcesosDeLimites2(empresas, cuentas, tarjetas, novedadesEmpresas, novedadesCuentas, novedadesTarjetas, cliente, limiteCompra);
            result = {
                ...state,
                seModifico: true,
                empresas: action.data.empresas,
                novedadesEmpresas: action.data.novedadesEmpresas,
                seEstaEditando: action.data.seEstaEditando,
                abrirModalEstaEditando: action.data.abrirModalEstaEditando,
                limiteEmpresaExcedido: excesoLimite.empresa,
                limiteCuentaExcedido: excesoLimite.cuenta,
                limiteTarjetasExcedido: excesoLimite.tarjeta
            };

            break;
        }

        case CAMBIAR_ESTADO_EDICION_CUENTAS: {
            const { empresas, tarjetas, novedadesEmpresas, novedadesTarjetas, limiteCompra } = state;
            const { cuentas, novedadesCuentas, cliente } = action.data;
            
            let excesoLimtie2 = _verificarExcesosDeLimites2(empresas, cuentas, tarjetas, novedadesEmpresas, novedadesCuentas, novedadesTarjetas, cliente, limiteCompra);

            result = {
                ...state,
                seModifico: true,
                cuentas: action.data.cuentas,
                novedadesCuentas: action.data.novedadesCuentas,
                seEstaEditando: action.data.seEstaEditando,
                abrirModalEstaEditando: action.data.abrirModalEstaEditando,
                limiteEmpresaExcedido: excesoLimtie2.empresa,
                limiteCuentaExcedido: excesoLimtie2.cuenta,
                limiteTarjetasExcedido: excesoLimtie2.tarjeta,
                limiteCompra: state.limiteCompra
            };
            break;
        }

        case CAMBIAR_ESTADO_EDICION_TARJETAS: {
            const { empresas, cuentas, novedadesEmpresas, novedadesCuentas, limiteCompra } = state;
            const { tarjetas, novedadesTarjetas, cliente } = action.data;

            let excesoLimtie3 = _verificarExcesosDeLimites2(empresas, cuentas, tarjetas, novedadesEmpresas, novedadesCuentas, novedadesTarjetas, cliente, limiteCompra);

            result = {
                ...state,
                seModifico: true,
                tarjetas: action.data.tarjetas,
                novedadesTarjetas: action.data.novedadesTarjetas,
                seEstaEditando: action.data.seEstaEditando,
                abrirModalEstaEditando: action.data.abrirModalEstaEditando,
                limiteEmpresaExcedido: excesoLimtie3.empresa,
                limiteCuentaExcedido: excesoLimtie3.cuenta,
                limiteTarjetasExcedido: excesoLimtie3.tarjeta
            };
            break;
        }

        case SET_USER_FUNCTIONS_DISTRIBUCION:

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case CLOSE_MODAL_ESTA_EDITANDO:

            result = {
                ...state,
                abrirModalEstaEditando: false
            };
            break;

        case OPEN_MODAL_ESTA_EDITANDO:

            result = {
                ...state,
                abrirModalEstaEditando: true
            };
            break;

        case READY_REQUEST_LIMITES:

            result = {
                ...state,
                readyRequest: true,
            };
            break;

        case SHOW_SAVE_STATUS_LIMITES:

            result = {
                ...state,
                readyRequest: false,
            };
            break;

        default:
            result = { ...state };
            break;
    }

    LogHelper.Out(distribucionLimites.name, result);
    return result;
}
export default distribucionLimites;

/**
 * 
 * @param {any} empresas
 * @param {any} cuentas
 * @param {any} tarjetas
 * @param {any} novedadesEmpresa
 * @param {any} novedadesCuenta
 * @param {any} novedadesTarjeta
 * @param {any} cliente
 * @param {any} atlasLimitesCompra
 */
function _verificarExcesosDeLimites2(empresas, cuentas, tarjetas, novedadesEmpresa, novedadesCuenta, novedadesTarjeta, cliente, atlasLimitesCompra) {
    LogHelper.In(_verificarExcesosDeLimites2.name, empresas, cuentas, tarjetas, novedadesEmpresa, novedadesCuenta, novedadesTarjeta, cliente, atlasLimitesCompra);
   
    const { LimiteAsignado, LimitePorCuit, LimiteSinAsignar } = cliente;

    let limiteEmpresaSinAsignarAux = 0;
    let limiteEmpresaAsignadoAux = 0;
    let excesos = {
        empresa: { excede: false },
        cuenta: { excede: false },
        tarjeta: { excede: false },
    }

    empresas.forEach((e, ei) => {
        let limiteEmpresaActual = e.LimiteCompra;
        let limiteCuentaActual = 0;

        if (e.esNueva == true) {
            limiteEmpresaSinAsignarAux -= parseFloat(e.LimiteCompra);
            limiteEmpresaAsignadoAux += parseFloat(e.LimiteCompra);
        } else {
            let novedadLimite = novedadesEmpresa.find(ne => ne.NovedadCampoCodigo == "LIMCO_EMPR" && ne.NovedadEstadoId == 1 && ne.EmpresaVisaId == e.Id);

            if (novedadLimite) {
                limiteEmpresaActual = parseFloat(novedadLimite.ValorNovedad);

                limiteEmpresaSinAsignarAux -= parseFloat(novedadLimite.ValorNovedad);
                limiteEmpresaAsignadoAux += parseFloat(novedadLimite.ValorNovedad);
            } else {
                limiteEmpresaSinAsignarAux -= parseFloat(e.LimiteCompra);
                limiteEmpresaAsignadoAux += parseFloat(e.LimiteCompra);
            }
        }

        cuentas.filter(c1 => c1.EmpresaVisaId == e.Id).forEach((c2, ci) => {
            let novedadCuenta = novedadesCuenta.find(nc => nc.NovedadCampoCodigo == "LIMCO_CUEN" && nc.NovedadEstadoId == 1 && nc.CuentaTarjetaId == c2.Id);
            let limiteTarjetaActual = 0;

            if (novedadCuenta) {
                const valor = atlasLimitesCompra.find(alc = alc.Id == novedadCuenta.ValorNovedad);

                if (valor) {
                    limiteCuentaActual += parseFloat(valor.Valor);
                }
            } else {
                limiteCuentaActual += parseFloat(c2.Valor);
            }

            tarjetas.filter(t1 => t1.CuentaTarjetaId == c2.Id).forEach((t2, ti) => {
                let novedadTarjeta = novedadesTarjeta.find(nt => nt.NovedadCampoCodigo == "LIMCO_TARJ" && nt.NovedadEstadoId == 1 && nt.TarjetaCreditoId == t2.Id);

                if (novedadTarjeta) {
                    limiteTarjetaActual += parseFloat(novedadTarjeta.ValorNovedad);
                } else {
                    limiteTarjetaActual += parseFloat(t2.PorcentajeLimiteCompra || 0)
                }

                if (limiteTarjetaActual > 100 && c2.ModalidadDistribucionLimiteId == 2) {
                    excesos.tarjeta.excede = true;
                }
            });
        });

        if (limiteEmpresaActual < limiteCuentaActual) {
            excesos.cuenta.excede = true;
        }
    });

    if (LimitePorCuit < limiteEmpresaAsignadoAux) {
        excesos.empresa.excede = true;
    }

    return excesos;
}

/**
 * 
 * @param {any} state
 */
function _verificarExcesosDeLimites(state) {
    LogHelper.In(_verificarExcesosDeLimites.name, state);

    let result = {
        'empresa': { excede: false },
        'cuenta': { excede: false, empresasIds: [] },
        'tarjeta': { excede: false, empresasIds: [], cuentasIds: [] }
    }

    let empresas = state.empresas;
    let novedadesEmpresas = state.novedadesEmpresas;
    let cuentas = state.cuentas;
    let novedadesCuentas = state.novedadesCuentas;
    let tarjetas = state.tarjetas;
    let novedadesTarjetas = state.novedadesTarjetas;

    let limiteString = GlobalHelper.EliminarDecimales(state.limiteCliente);
    let limite = parseInt(limiteString);

    //Empresa...
    for (let i = 0; i < empresas.length; i++) {
        let novedad = novedadesEmpresas.find(x => x.EmpresaId == empresas[i].Id)
        if (novedad !== undefined) {
            limite -= parseInt(novedad.ValorNovedad);
        } else {
            limite -= parseInt(empresas[i].LimiteCompra);
        }
    }

    let limiteEmpresaExcedido;
    if (limite < 0) {
        result.empresa.excede = true;
    }

    //Cuentas...
    for (var i = 0; i < empresas.length; i++) {
        let limiteEmpresa = 0;
        let limiteCuentas = 0;

        let ne = novedadesEmpresas.find(x => x.EmpresaId == empresas[i].Id);

        if (ne == undefined) {
            ne = novedadesEmpresas.find(x => x.EmpresaVisaId == empresas[i].Id);
        }

        if (ne !== undefined) {
            limiteEmpresa = parseInt(ne.ValorNovedad);
        } else {
            limiteEmpresa = parseInt(empresas[i].LimiteCompra);
        }

        for (var j = 0; j < cuentas.length; j++) {
            if (cuentas[j].EmpresaId == empresas[i].Id) {
                let nc = novedadesCuentas.find(x => x.CuentaTarjetaId == cuentas[j].Id);
                if (nc !== undefined) {
                    limiteCuentas += parseInt(nc.ValorNovedad);
                } else {
                    limiteCuentas += parseInt(cuentas[j].Valor);
                }
            }
            else {
                if (cuentas[j].EmpresaVisaId == empresas[i].Id) {
                    let ncc = novedadesCuentas.find(x => x.CuentaTarjetaId == cuentas[j].Id);
                    if (ncc !== undefined) {
                        limiteCuentas += parseInt(ncc.ValorNovedad);
                    } else {
                        limiteCuentas += parseInt(cuentas[j].Valor);
                    }
                }
            }
        }

        if (limiteCuentas > limiteEmpresa) {
            result.cuenta.excede = true;
            result.cuenta.empresasIds.push(empresas[i].Id);
        }
    }

    //Tarjetas...
    for (var i = 0; i < cuentas.length; i++) {
        let limiteTarjeta = 0;
        for (var j = 0; j < tarjetas.length; j++) {
            if (cuentas[i].Id == tarjetas[j].CuentaId) {
                let nt = novedadesTarjetas.find(x => x.TarjetaCreditoId == tarjetas[j].Id);
                if (nt) {
                    limiteTarjeta += parseInt(nt.ValorNovedad);
                } else {
                    limiteTarjeta += parseInt(tarjetas[j].Limite);
                }
            }
        }
        if (limiteTarjeta > 100 && state.cuentas[i].ModalidadDistribucionLimiteId != 2) {
            result.tarjeta.excede = true;

            if (cuentas[i].EmpresaId != undefined) {
                result.tarjeta.empresasIds.push(cuentas[i].EmpresaId);
            }
            else {
                result.tarjeta.empresasIds.push(cuentas[i].EmpresaVisaId);
            }

            result.tarjeta.cuentasIds.push(cuentas[i].Id);
        }
    }

    LogHelper.Out(_verificarExcesosDeLimites.name, result);
    return result;
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Store/Reducers/DistribucionLimites.js